import { useNavigate } from 'react-router';
import { Flex, ScrollArea } from '@/components/common';
import { PageTopBar } from '@/components/layout';
import { Paywall } from '@/components/subscription/Paywall';

export function PaywallPage() {
  const navigate = useNavigate();

  return (
    <Flex className="relative h-screen w-full overflow-hidden bg-black" direction="column">
      <PageTopBar
        backButton
        className="absolute top-0 right-0 left-0 z-10"
        onBack={() => navigate('/account/subscription')}
      />
      <ScrollArea className="flex-1">
        <Paywall />
      </ScrollArea>
    </Flex>
  );
}
